import {AiCompletionRestService} from './restServices';
import storageService from '../storageService';
import utilsService from '../utilsService';

var service = {};

service.generateCompletion = async (
  ownerObjectType,
  ownerObjectId,
  parentWidgetId,
  chatRoomId,
  conversationContextDto,
) => {
  const token = storageService.getItem('token');
  const requestObj = {
    token,
    ownerObjectType,
    ownerObjectId,
    parentWidgetId,
    chatRoomId,
    conversationContextDto,
    chatPrompt: '',
  };
  const response = await AiCompletionRestService.save({}, requestObj);

  utilsService.logApiResponse('generateCompletion', response.data);
  return response.data;
};

service.stopCompletion = async (
  chatRoomId,
  chatMessageId,
  llmCompletionFlowId,
  isDemoCompletion,
) => {
  const token = isDemoCompletion ? storageService.getItem('token') : null;
  const requestObj = {
    endpoint: 'chatRoomId',
    endpointParam: chatRoomId,
    endpoint2: 'chatMessageId',
    endpointParam2: chatMessageId,
    endpoint3: 'llmCompletionFlowId',
    endpointParam3: llmCompletionFlowId,
  };
  const response = await AiCompletionRestService.delete(requestObj, {token});

  utilsService.logApiResponse('stopCompletion', response.data);
  return response.data;
};

const aiCompletionService = {...service};
export default aiCompletionService;
